/**
 * ammoDisplay — the dependency-free part of the per-slot ammo label.
 *
 * Kept free of PIXI and the DOM so it runs in Node tests.
 */
import { WeaponFireMode } from '../../../../shared/Weapon.js';

/**
 * What an inventory slot should print for its weapon's ammo.
 *
 * The pickaxe is excluded by fireMode, not by its numbers: Weapon's
 * constructor falls back to `config.magCapacity || 30`, so the pickaxe's
 * configured 0 still ends up as a real-looking 30 on the instance.
 *
 * @param {{ magCapacity?: number, fireMode?: string, ammoType?: string }|null|undefined} item - the slot's item
 * @param {{ currentAmmo?: number, unlimitedAmmo?: boolean }|null|undefined} weaponState
 * @param {Record<string, number>|null|undefined} pouch - the local player's ammo pouch
 * @param {boolean} [unlimited=false] - the mode never runs guns dry (FFA, TDM, Gun Game:
 *   `gameModeConfig.unlimitedAmmo`). Client slot weaponStates are rebuilt with
 *   createState(), so their own unlimitedAmmo is always false; this is the real signal.
 * @returns {{ mag: string, reserve: string }|null} null = show no ammo text
 */
export function slotAmmoView(item, weaponState, pouch = null, unlimited = false) {
  if (!item || !weaponState) return null;
  if (item.magCapacity === undefined || item.fireMode === WeaponFireMode.MELEE) return null;

  return {
    mag: `${Math.round(weaponState.currentAmmo || 0)}/${item.magCapacity}`,
    reserve: (unlimited || weaponState.unlimitedAmmo) ? '∞' : String(Math.round(pouch?.[item.ammoType] || 0))
  };
}
